import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pu-header, [puHeader]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() breakpoints: { isTabletMode: boolean; isDesktopMode: boolean };
  @Input() isShadowVisible: boolean;
}
